import sortBy from '~/commun/utils/sortBy'
export default {
  data() {
    return {
      customValues: {},
    }
  },
  computed: {
    customizations() {
      const sortByPosition = sortBy('position')

      const customs = sortByPosition(this.product?.customizations ?? [])

      if (this.isGift) {
        customs.forEach((custom) => {
          if (
            ['', null, undefined].includes(
              custom.line_item_customization?.value
            )
          )
            delete custom.line_item_customization
        })
      }

      return customs
    },
  },
}
